import React from "react";

let Navigation = require("../components/nounproject-navigation");

class NounProjectContainer extends React.Component {
    render() {
        let navigation = this.renderNavigation();

        return (
            <div>
                {navigation}
                {this.props.children}
            </div>
        );
    }

    renderNavigation() {
        let noSearch = false;

        if (this.props.route.path === "/") {
            // if we are on the homepage remove search from the navigation
            noSearch = true;
        }
        return <Navigation noSearch={noSearch} />;
    }
}

module.exports = NounProjectContainer;
